export const API_AUTH_GS_V1 = `${process.env.REACT_APP_AUTH_GS_BASE_URL}/api/v1/`